import React, { Component } from 'react'
//import axios from "axios";

import Header from './Header';
import Footer from './Footer';
import Table from 'react-bootstrap/Table'

// ---------------------------------------------------------------------------
// Client data
// ---------------------------------------------------------------------------
const CLIENTS = [
  { id: 1,  name: 'ORANGE COUNTY SCHOOL, RAJSAMAND',                        district: 'Rajsamand',  type: 'School',    website:'http://www.orangecountyschool.in'   },
  { id: 2,  name: 'MAHATMA GANDHI MAHAVIDHALAYA, BARMER',                   district: 'Barmer',      type: 'College',  website:'mgcollegegida.com'     },
  { id: 3,  name: 'SMS School, Jaipur',                                     district: 'Jaipur',    type: 'School',    website:'www.msmsvjaipur.com' },
  { id: 4,  name: 'APC College, Pratapgarh',                                district: 'Pratapgarh', type: 'College',  website:'www.apcpratapgarh.com'     },
  { id: 5,  name: 'Delhi Public School',                                    district: 'Sikar',     type: 'School',    website:''    },
  { id: 6,  name: 'Pratap Public Sr. Sec. School, Balawala',                district: 'Jaipur',    type: 'School',   website:'http://www.pratapschool.in'     },
  { id: 7,  name: 'Mohta Public School, Churu',                             district: 'Churu',     type: 'School',  website:''      },
  { id: 8,  name: 'Jaipur Public School, Taranagar',                        district: 'Churu',     type: 'School',   website:'www.jpstaranagar.com'     },
  { id: 9,  name: 'Shri Vaishnav Sr. Sec. Shiksha Sadan',                   district: 'Jodhpur',    type: 'School',   website:'www.shrivaishnavschool.com'     },
  { id: 10, name: 'Gurukul Shikshan Sansthan Sr Sec School',                district: 'Bikaner',     type: 'School',  website:''      },
  { id: 11, name: 'Hallmark International Sr Sec school',                  district: 'Jaipur',      type: 'School',  website:''      },
  { id: 12, name: 'Gems public Sr sec school',                              district: 'Jaipur',      type: 'School',  website:''      },
  { id: 13, name: 'Lords International School, Sadulpur',                  district: 'Churu',       type: 'School',   website:''     },
  { id: 14, name: 'Saraswati Shikshan Sansthan',                            district: 'Bikaner',     type: 'School',  website:''      },
  { id: 15, name: 'Cambridge Court World School',                           district: 'Jaipur',      type: 'School',   website:''     },
  { id: 16, name: 'Shri Ram Public Secondary School',                       district: 'Bikaner',     type: 'School',  website:''      },
  { id: 17, name: 'M.S. SHIKSHAN SANSTHAN',                                 district: 'Bikaner',     type: 'School',   website:''     },
  { id: 18, name: 'IICE COMPUTER EDUCATION, SADULPUR',                     district: 'Churu',       type: 'RKCL Center', website:''  },
  { id: 19, name: 'SUNRISE CHILDREN ACADEMY SENIOR SECONDARY SCHOOL',district: 'Sikar',type: 'School',    website:''    },
  { id: 20, name: 'Mahaveer Convent Sr Sec School',                         district: 'Dholpur',     type: 'School',     website:''   },
  { id: 21, name: 'Star Public School',                                     district: 'Khairthal',   type: 'School',     website:''   },
  { id: 22, name: 'SHARDA PUBLIC SENIOR SECONDARY SCHOOL',                  district: 'Jaipur',      type: 'School',     website:''   },
  { id: 23, name: 'Cambridge Court International School (CCIS)',           district: 'Jaipur',      type: 'School',      website:''  },
  { id: 24, name: 'BRIGHT MOON SR SEC SCHOOL',                              district: 'Sikar',       type: 'School',     website:''   },
  { id: 25, name: 'SIKAR VIDYA PUBLIC SCHOOL KUSHALGARH',                   district: 'Banswara',    type: 'School',     website:''   },
  { id: 26, name: 'Gyan Jyoti Shikshan Sanstha Sr .Sec . School Khandela',  district: 'Sikar',       type: 'School',     website:''   },
  { id: 27, name: 'Green flower kids Care Public SR Sec School',            district: 'Jhunjhunu',   type: 'School',     website:''   },
  { id: 28, name: 'G R G School and Academy',                               district: 'Sikar',       type: 'School',     website:''   },
  { id: 29, name: 'MAHALAXMI PUBLIC SCHOOL KARNA',                          district: 'Balotra',     type: 'School',     website:''   },
  { id: 30, name: 'EKLAVYA PUBLIC SHIKSHAN SANSTHAN',                       district: 'Bikaner',     type: 'School',     website:''   },
  { id: 31, name: 'Gyandeep Public Academy',                                district: 'Bikaner',     type: 'School',     website:''   },
];

const PLAN_STYLES = {
  Basic: { color: '#2563eb', bg: '#eff6ff', border: '#bfdbfe' },
  Pro:   { color: '#059669', bg: '#ecfdf5', border: '#a7f3d0' },
  Ultra: { color: '#7c3aed', bg: '#f5f3ff', border: '#ddd6fe' },
};

const PlanBadge = ({ plan }) => {
  const s = PLAN_STYLES[plan] || { color: '#64748b', bg: '#f8fafc', border: '#e2e8f0' };
  return (
    <span
      className="plan-badge"
      style={{ color: s.color, background: s.bg, borderColor: s.border }}
    >
      {plan}
    </span>
  );
};

export class Client extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: true,
    }
  }

  async getUsersData() {
    // Static client roster — update CLIENTS above to add/edit schools
    this.setState({ loading: false, users: CLIENTS });
  }

  componentDidMount() {
    this.getUsersData()
  }

  render() {
    const { users, loading } = this.state;

    return (
      <div>
        <Header />
        <div className="container pb-5">
          <section className="guest_opinion pt-5">

            <div className="client-heading">
              
              <h3 className="client-title">SchoolEasy Client List</h3>
              <p className="client-subtitle">
                 Schools, Colleges & RKCL Centers` running on SchoolEasy.
              </p>
            </div>

            <div className="table-responsive client-table-wrap" id="dealer">
              <Table className="client-table" striped>
                <thead>
                  <tr>
                    <th className="col-no">S.No.</th>
                    <th className="col-name">SchoolEasy Client</th>
                    <th className="col-type">Type</th>
                    <th className="col-district">District</th>
                    <th className="col-type">Website</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan={6} className="text-center py-4">Loading clients…</td>
                    </tr>
                  )}
                  {!loading && users.map((c, i) => (
                    <tr key={c.id + '-' + i}>
                      <td className="col-no">{i + 1}</td>
                      <td className="col-name">{c.name}</td>
                      <td className="col-type">{c.type}</td>
                      <td className="col-district">{c.district}</td>
                      <td className="col-fy">{c.website}</td>
                      {/*<td className="col-plan"><PlanBadge plan={c.plan} /></td>*/}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

          </section>
        </div>
        <Footer />

        <style>{`
          .client-heading {
            text-align: center;
            max-width: 620px;
            margin: 0 auto 2rem;
          }
          .client-eyebrow {
            display: inline-block;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: #2563eb;
            background: #eff6ff;
            border: 1px solid #bfdbfe;
            padding: 0.3rem 0.85rem;
            border-radius: 999px;
            margin-bottom: 0.9rem;
          }
          .client-title {
            font-size: clamp(1.5rem, 3vw, 2.1rem);
            font-weight: 800;
            color: #0f172a;
            margin: 0 0 0.5rem;
          }
          .client-subtitle {
            font-size: 0.95rem;
            color: #64748b;
            margin: 0;
          }

          .client-table-wrap {
            border-radius: 14px;
            overflow: auto;
            box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
            border: 1px solid #e2e8f0;
          }
          .client-table {
            width: 100%;
            margin-bottom: 0;
            font-size: 0.9rem;
          }
          .client-table thead th {
            position: sticky;
            top: 0;
            background: linear-gradient(135deg, #5d5d5d, #393d46);
            color: #fff;
            font-weight: 700;
            padding: 0.85rem 0.9rem;
            border-bottom: none;
            white-space: nowrap;
          }
          .client-table tbody td {
            padding: 0.65rem 0.9rem;
            vertical-align: middle;
            color: #1e293b;
          }
          .client-table .col-no { text-align: center;  font-weight: 600; width: 5%; }
          .client-table .col-name { font-weight: 600; width: 32%; }
          .client-table .col-fy { text-align: center; white-space: nowrap; color: #475569; }
          .client-table .col-type { text-align: center; white-space: nowrap; }
          .client-table .col-plan { text-align: center; white-space: nowrap; }

          .plan-badge {
            display: inline-block;
            font-size: 0.75rem;
            font-weight: 700;
            padding: 0.25rem 0.7rem;
            border-radius: 999px;
            border: 1px solid;
          }

          @media (max-width: 768px) {
            .client-table { font-size: 0.8rem; }
            .client-table thead th, .client-table tbody td { padding: 0.55rem 0.5rem; }
          }
        `}</style>
      </div>
    )
  }
}

export default Client
